const Icon = (props: any) => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.08301 13.5002C1.08301 13.5002 5.41634 4.8335 12.9997 4.8335C20.583 4.8335 24.9163 13.5002 24.9163 13.5002C24.9163 13.5002 20.583 22.1668 12.9997 22.1668C5.41634 22.1668 1.08301 13.5002 1.08301 13.5002Z"
      stroke="white"
      strokeWidth="2.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9997 16.7502C14.7946 16.7502 16.2497 15.2951 16.2497 13.5002C16.2497 11.7052 14.7946 10.2502 12.9997 10.2502C11.2047 10.2502 9.74967 11.7052 9.74967 13.5002C9.74967 15.2951 11.2047 16.7502 12.9997 16.7502Z"
      stroke="white"
      strokeWidth="2.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
